
import React, { useState } from "react";
import {
  Edit,
  Trash,
  Search,
  ChevronUp,
  ChevronDown,
} from "lucide-react";
import "./Product.css";

export default function Product() {
  const [search, setSearch] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: "price", direction: "asc" });

  const [products, setProducts] = useState([
    { id: 1, name: "Gaming PC", price: 65000, stock: 12, status: "Active" },
    { id: 2, name: "Office PC", price: 35000, stock: 8, status: "Inactive" },
    { id: 3, name: "Editing PC", price: 82000, stock: 5, status: "Active" },
    { id: 4, name: "Basic PC", price: 25000, stock: 20, status: "Active" },
  ]);

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") direction = "desc";
    setSortConfig({ key, direction });
  };

  const sortedProducts = [...products].sort((a, b) => {
    let aValue = a[sortConfig.key];
    let bValue = b[sortConfig.key];

    if (typeof aValue === "string") aValue = aValue.toLowerCase();
    if (typeof bValue === "string") bValue = bValue.toLowerCase();

    if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
    if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });

  const filtered = sortedProducts.filter((p) =>
    Object.values(p).some((v) => String(v).toLowerCase().includes(search.toLowerCase()))
  );

  const SortIcons = ({ columnKey }) => {
    const isActive = sortConfig.key === columnKey;
    return (
      <span className="adproduct-sort-icons"   style={{ display: "inline-flex", flexDirection: "column", marginLeft: 5 }}>
        <ChevronUp size={12} color={isActive && sortConfig.direction === "asc" ? "#568ddf" : "#ccc"} />
        <ChevronDown size={12} color={isActive && sortConfig.direction === "desc" ? "#568ddf" : "#ccc"} />
      </span>
    );
  };

  return (
    <div className="adproduct-container">
      <h2 className="adproduct-title">Product List</h2>

      <div className="adproduct-top-bar">
        <div className="adproduct-search-box">
          <Search size={20} />
          <input
            type="text"
            placeholder="Search product..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      <div className="adproduct-table-container">
        <table className="adproduct-table">
          <thead>
            <tr>
              <th onClick={() => handleSort("name")} style={{ cursor: "pointer" }}>
                PC Name <SortIcons columnKey="name" />
              </th>
              <th onClick={() => handleSort("price")} style={{ cursor: "pointer" }}>
                Price <SortIcons columnKey="price" />
              </th>
              <th onClick={() => handleSort("stock")} style={{ cursor: "pointer" }}>
                Stock <SortIcons columnKey="stock" />
              </th>
              <th onClick={() => handleSort("status")} style={{ cursor: "pointer" }}>
                Status <SortIcons columnKey="status" />
              </th>
              <th style={{ textAlign: "center" }}>Actions</th>
            </tr>
          </thead>

          <tbody>
            {filtered.map((p) => (
              <tr key={p.id}>
                <td>{p.name}</td>
                <td>₹{p.price}</td>
                <td>{p.stock}</td>
                <td>
                  <span
                    className={
                      p.status === "Active" ? "adproduct-active" : "adproduct-inactive"
                    }
                  >
                    {p.status}
                  </span>
                </td>
                <td className="adproduct-actions">
                  <Edit className="adproduct-edit" />
                  <Trash className="adproduct-delete" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}